/**
 * ProjectStatusService
 * Service for ProjectStatus entity operations
 * Route: api/project-status
 * Controller: ProjectStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * ProjectStatusService
 * Handles project status CRUD operations
 * Maps to /api/project-status endpoint
 */
export class ProjectStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ProjectStatusService.DEFAULT_SERVICE_PATH,
            basePath: ProjectStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CUSTOM METHODS ====================
    /**
     * Invalidate project status cache
     * POST /api/project-status/cache/invalidate
     * @returns Success status
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate cache (raw)
     * @returns ResponseData with success status
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('invalidateCache', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
ProjectStatusService.DEFAULT_SERVICE_PATH = 'projects';
ProjectStatusService.BASE_PATH = 'api/project-status';
//# sourceMappingURL=ProjectStatusService.js.map